export const SOFTWARE_COLOR = '#a6ccff';
export const MARKETPLACE_COLOR = '#FFC02E';
